import React from 'react'
import {AiFillGithub} from 'react-icons/ai'
export default function Footer() {
  return (
<>
<div className=' h-20 bg-[#a30c0c] flex justify-between p-5'>
<div>
<a href="/"><img src={process.env.PUBLIC_URL+'/logo.png'} alt="..." className=' w-10 lg:w-14' /></a>
</div>
<div className=' text-3xl lg:text-xl font-[Poppins] font-bold'>
All Rights Reserved
</div>
<div>
<a href="https://github.com/Samit-prsl/Gym_Upp"><AiFillGithub className=' text-4xl text-white'/></a>
</div>
</div>
</>
  )
}
